import { useCallback } from 'react';
import { update } from '../services/item';
import store from '../store/store';
import { normalizeMapState } from '../components/board/map/boardMapDefaults.js';

export const useBoardMapPersistence = ({ tab }) => {
  const buildLatestMapState = useCallback(() => {
    const latestState = store.getState();
    const latestTab = latestState?.items?.[tab?._id] || tab;
    return normalizeMapState(latestTab?.map);
  }, [tab]);

  const persistMap = useCallback(
    async partial => {
      if (!tab?._id) {
        return;
      }
      const currentMap = buildLatestMapState();
      await update(
        `items/${tab._id}`,
        'map',
        {
          ...currentMap,
          ...(partial || {}),
        },
      );
    },
    [buildLatestMapState, tab],
  );

  const persistMapField = useCallback(
    async (field, value) => {
      if (!tab?._id || !field) {
        return;
      }
      const currentMap = buildLatestMapState();
      await update(`items/${tab._id}`, 'map', {
        ...currentMap,
        [field]: value,
      });
    },
    [buildLatestMapState, tab?._id],
  );

  return {
    persistMap,
    persistMapField,
  };
};
